import React from 'react';

const About = () => {
  return (
    <section className="py-5 bg-light" id="about">
      <div className="container py-5">
        <div className="row g-5 align-items-center">
          <div className="col-xl-6">
            <div>
              <h4 className="text-primary mb-4">About MastiShorts</h4>
              <h1 className="display-5 fw-bold mb-4">The Best Live Streaming For You And Your Family</h1>
              <p className="lead text-muted mb-5">
                MastiShorts is India's favorite platform for live streaming and short video creation — made for creators, entertainers, and everyday fun. Whether you want to perform live, share moments, or simply enjoy watching others, MastiShorts brings people together with joy, safety, and creativity.
              </p>
              
              <div className="row g-4">
                <div className="col-md-6">
                  <div className="d-flex align-items-start">
                    <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center me-3 shadow-sm" style={{width: '60px', height: '60px', flexShrink: 0}}>
                      <i className="fas fa-glass-cheers fa-2x"></i>
                    </div>
                    <div>
                      <h5 className="fw-bold mb-2">New Features</h5>
                      <p className="text-muted mb-0">
                        Enjoy our latest updates including multi-host live rooms, interactive gifts, and enhanced video filters that take your content to the next level.
                      </p>
                    </div>
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="d-flex align-items-start">
                    <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center me-3 shadow-sm" style={{width: '60px', height: '60px', flexShrink: 0}}>
                      <i className="fas fa-dot-circle fa-2x"></i>
                    </div>
                    <div>
                      <h5 className="fw-bold mb-2">Many Attractions</h5>
                      <p className="text-muted mb-0">
                        From live games to trending challenges, MastiShorts is packed with exciting content that keeps you entertained every day.
                      </p>
                    </div>
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="d-flex align-items-start">
                    <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center me-3 shadow-sm" style={{width: '60px', height: '60px', flexShrink: 0}}>
                      <i className="fas fa-hand-holding-usd fa-2x"></i>
                    </div>
                    <div>
                      <h5 className="fw-bold mb-2">Affordable Price</h5>
                      <p className="text-muted mb-0">
                        Stream, create, and engage — all without breaking the bank. Premium features at low cost and with great value.
                      </p>
                    </div>
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="d-flex align-items-start">
                    <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center me-3 shadow-sm" style={{width: '60px', height: '60px', flexShrink: 0}}>
                      <i className="fas fa-lock fa-2x"></i>
                    </div>
                    <div>
                      <h5 className="fw-bold mb-2">Privacy & Security</h5>
                      <p className="text-muted mb-0">
                        We take your privacy seriously. Stream and interact with confidence thanks to our secure and user-friendly system.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-xl-6">
            <div className="position-relative">
              <div className="position-relative bg-primary rounded-4 p-3 mb-4 shadow-lg" style={{ marginTop: '40px' }}>
                <div className="bg-white rounded-4 p-3 text-center">
                  <h4 className="fw-bold text-primary mb-0">
                    <i className="fas fa-award me-2"></i>
                    20 Years Experience
                  </h4>
                </div>
              </div>
              
              <div className="row g-0">
                <div className="col-lg-12">
                  <div className="rounded-4 overflow-hidden shadow-lg mb-4">
                    <img src="/img/aboutus.png" className="img-fluid w-100" alt="About MastiShorts" style={{ height: '300px', objectFit: 'cover' }} />
                  </div>
                  
                  <div className="row gx-4 gy-0">
                    <div className="col-6">
                      <div className="bg-primary text-white rounded-4 text-center p-4 shadow hover-lift">
                        <div className="mb-3">
                          <i className="fas fa-thumbs-up fa-3x"></i>
                        </div>
                        <div className="mb-2">
                          <span className="fs-2 fw-bold">150</span>
                          <span className="h1 fw-bold">K+</span>
                        </div>
                        <h6 className="mb-0">Happy Users</h6>
                      </div>
                    </div>
                    
                    <div className="col-6">
                      <div className="bg-dark text-white rounded-4 text-center p-4 shadow hover-lift">
                        <div className="mb-3">
                          <i className="fas fa-certificate fa-3x"></i>
                        </div>
                        <div className="mb-2">
                          <span className="fs-2 fw-bold">122</span>
                          <span className="h1 fw-bold">+</span>
                        </div>
                        <h6 className="mb-0">Awards Winning</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
